import type { ParsedTicketData } from '../components/UploadTicket/UploadTicket';

export interface ParsedTicketFormSetters {
  setTicketNumber: (value: string) => void;
  setTicketCitation: (value: string) => void;
  setTicketAddress: (value: string) => void;
  setTicketCity: (value: string) => void;
  setTicketCounty: (value: string) => void;
  setTicketCourtDate: (value: string) => void;
  setTicketLicenseType: (value: string) => void;
}

export function applyParsedTicketData(
  parsedData: ParsedTicketData,
  setters: ParsedTicketFormSetters,
): void {
  if (parsedData.Ticket_Number)
    setters.setTicketNumber(parsedData.Ticket_Number);
  if (parsedData.Ticket_Citation)
    setters.setTicketCitation(parsedData.Ticket_Citation);
  if (parsedData.Ticket_Address)
    setters.setTicketAddress(parsedData.Ticket_Address);
  if (parsedData.Ticket_City) setters.setTicketCity(parsedData.Ticket_City);
  if (parsedData.Ticket_County)
    setters.setTicketCounty(parsedData.Ticket_County);
  if (parsedData.Ticket_LicenseType)
    setters.setTicketLicenseType(parsedData.Ticket_LicenseType);

  if (parsedData.Ticket_CourtDate) {
    const courtDate = new Date(parsedData.Ticket_CourtDate);
    if (!Number.isNaN(courtDate.getTime())) {
      setters.setTicketCourtDate(courtDate.toISOString().split('T')[0]);
    } else {
      setters.setTicketCourtDate(parsedData.Ticket_CourtDate);
    }
  }
}
